var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageType === _vm.pageConfig.personal.type)?_c('PersonalAdd'):(_vm.pageType === _vm.pageConfig.enterprise.type)?_c('EnterpriseAdd'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }